<div
  class="form-group container d-flex justify-content-center align-items-center h-100"
>
  <div class="row" *ngIf="errorObs | async as error">
    <div class="row align-items-center justify-content-center">
      <div *ngIf="error.icon" class="error-page-icon pull-left">
        <i [ngClass]="error.icon" class="glyphicon"> </i>
      </div>
      <div class="pull-left">
        <h1 data-e2e-id="error-page-title">
          {{ error.title || defaultErrorTitle | translate }}
        </h1>
        <p data-e2e-id="error-page-description" *ngIf="error.description">
          {{ error.description | translate }}
        </p>

        <p data-e2e-id="error-page-description" *ngIf="error.details">
          {{ error.details | translate }}
        </p>
        <a *ngIf="error.redirectLink" routerLink="{{ error.redirectLink }}">{{
          error.redirectText | translate
        }}</a>
      </div>
    </div>
  </div>
</div>
